import { loadPersonDetail, showPersonDetail } from '../person/person-detail.js'
import { loadPersonEdit, showPersonEdit } from '../person/person-edit.js'
import { showPersonList, loadPersonListData } from '../person/person-list.js'
import { loadPersonAdd, showPersonAdd } from '../person/person-add.js'
import { loadPasswordSetup, showPasswordSetup } from '../profile/password-setup.js'
import { loadUserProfile, showUserProfile } from '../profile/user-profile.js'

// Parse URL parameters
function getUrlParams() {
  const params = new URLSearchParams(window.location.search)
  return {
    personId: params.get('person'),
    edit: params.get('edit') === 'true',
    view: params.get('view') || 'list',
    add: params.get('add') === 'true',
    passwordSetup: params.get('password-setup') === 'true',
    profile: params.get('profile') === 'true'
  }
}

// Navigate to person detail
export function navigateToPerson(personId) {
  const newUrl = `${window.location.pathname}?person=${personId}`
  window.history.pushState({ personId }, '', newUrl)
  showPersonDetail()
  loadPersonDetail(personId)
}

// Navigate to person edit
export function navigateToPersonEdit(personId) {
  const newUrl = `${window.location.pathname}?person=${personId}&edit=true`
  window.history.pushState({ personId, edit: true }, '', newUrl)
  showPersonEdit()
  loadPersonEdit(personId)
}

// Navigate to person add
export function navigateToPersonAdd() {
  const newUrl = `${window.location.pathname}?add=true`
  window.history.pushState({ add: true }, '', newUrl)
  showPersonAdd()
  loadPersonAdd()
}

// Navigate to password setup
export function navigateToPasswordSetup() {
  const newUrl = `${window.location.pathname}?password-setup=true`
  window.history.pushState({ passwordSetup: true }, '', newUrl)
  showPasswordSetup()
  loadPasswordSetup()
}

// Navigate to user profile
export function navigateToUserProfile() {
  const newUrl = `${window.location.pathname}?profile=true`
  window.history.pushState({ profile: true }, '', newUrl)
  showUserProfile()
  loadUserProfile()
}

// Navigate to list
export function navigateToList() {
  const newUrl = window.location.pathname
  window.history.pushState({}, '', newUrl)
  showPersonList()
  loadPersonListData()
}

// Handle browser back/forward buttons
window.addEventListener('popstate', () => {
  const params = getUrlParams()
  if (params.profile) {
    showUserProfile()
    loadUserProfile()
  } else if (params.passwordSetup) {
    showPasswordSetup()
    loadPasswordSetup()
  } else if (params.add) {
    showPersonAdd()
    loadPersonAdd()
  } else if (params.personId && params.edit) {
    showPersonEdit()
    loadPersonEdit(params.personId)
  } else if (params.personId) {
    showPersonDetail()
    loadPersonDetail(params.personId)
  } else {
    showPersonList()
  }
})

// Initialize router on page load (after authentication)
export function initRouter() {
  const params = getUrlParams()
  if (params.profile) {
    showUserProfile()
    loadUserProfile()
  } else if (params.passwordSetup) {
    showPasswordSetup()
    loadPasswordSetup()
  } else if (params.add) {
    showPersonAdd()
    loadPersonAdd()
  } else if (params.personId && params.edit) {
    showPersonEdit()
    loadPersonEdit(params.personId)
  } else if (params.personId) {
    showPersonDetail()
    loadPersonDetail(params.personId)
  }
  
  // Back to list button handler
  document.getElementById('back-to-list-btn').addEventListener('click', () => {
    navigateToList()
  })
}
